import { useQBankStructure } from '@exam-management/qbs-provider';
import { Box, Flex, Loading } from '@shared/components';

import { useEditQBSLevelItem } from '../../providers';
import { QBankStructureLevelItemRowWithAction } from '../qbank-structure-level-item-row-with-action';

import { QBankStructureLevelItem } from './qbank-structure-level-item';
import type { DisplayQBankStructureLevelItem } from './types';
import { findLevelItemParentById } from './utils';

export default function QBankStructureLevelItemList() {
  const { qBankStructureInformation } = useQBankStructure();
  const { levelItems: qBankStructureLevelItems } = useEditQBSLevelItem();

  const sortedQBankStructureLevelItems = qBankStructureLevelItems.sort((a, b) => {
    if (a.qBankStructureLevel.level === b.qBankStructureLevel.level) {
      return a.order - b.order;
    }
    return a.qBankStructureLevel.level - b.qBankStructureLevel.level;
  });

  const [rootLevelItem, ...otherLevelItems] = sortedQBankStructureLevelItems;

  const displayItems = otherLevelItems.reduce<DisplayQBankStructureLevelItem[]>((acc, item) => {
    const newItem = { ...item, children: [] };
    if (!item.parentLevelItemId) {
      return [...acc, newItem];
    }

    const parentItem = findLevelItemParentById(acc, item.parentLevelItemId);
    if (!parentItem) {
      return [...acc, newItem];
    }

    if (!parentItem.children) {
      parentItem.children = [];
    }

    parentItem.children.push(newItem);
    return acc;
  }, []);

  if (!qBankStructureInformation || !rootLevelItem) {
    return (
      <Loading
        height='100%'
        sx={{
          minHeight: '200px',
        }}
      />
    );
  }

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(4), p: theme.spacing(6) })}>
      <QBankStructureLevelItemRowWithAction id={rootLevelItem.id} />
      {displayItems.map((item) => (
        <Box
          key={item.id}
          sx={(theme) => ({
            border: `1px solid ${theme.palette.grey[300]}`,
            overflow: 'hidden',
            borderRadius: theme.shape.rounded(2),
          })}
        >
          <QBankStructureLevelItem item={item} index={0} />
        </Box>
      ))}
    </Flex>
  );
}
